<app-shared
    *ngIf="fournisseurId != null"
    [type]="docType"
    [fournisseurScopeId]="fournisseurId"
></app-shared>
